import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'QuitPlinkoMinigamePopupLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '09160095-1666-4c71-ae23-3413c2cc02bf',
      type: 'NineSlicePlane',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 425,
        y: 325
      },
      width: 850,
      height: 650,
      leftWidth: 102,
      topHeight: 180,
      rightWidth: 92,
      bottomHeight: 141,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_board',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '5ef14362-a7a1-47ae-b33e-3697bd46c5e4',
      type: 'NineSlicePlane',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 425,
        y: 325
      },
      width: 850,
      height: 650,
      leftWidth: 102,
      topHeight: 180,
      rightWidth: 92,
      bottomHeight: 141,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_board',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '438407f5-4a37-441a-bdd4-1d798e40e873',
      type: 'NineSlicePlane',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 50,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 360,
        y: 160
      },
      width: 720,
      height: 320,
      leftWidth: 102,
      topHeight: 180,
      rightWidth: 92,
      bottomHeight: 141,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_border',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '0eb21893-d197-43c7-b34a-30805b204fa2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: 'a9c52cb0-7c59-4425-8bfe-16026d4f69e2',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -162,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PlinkoQuitInfo',
      localize: true,
      maxWidth: 600,
      maxHeight: 105,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba372b',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -6,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: 'e2d081f0-c414-4d55-bf8e-23a62a9ac818',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 171,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'plinko_mini_window',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: 'c65c80a2-0014-4e1d-acb0-90ec0d0283c2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -241,
      y: 56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'plinko_card_window',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '8462d869-2ce8-47db-b612-0d71ee580608',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -89,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'plinko_arrow_window',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '57a36700-d2f8-42cc-8a2d-8e424222efec',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 361,
      y: -260,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '15a08cd5-9a0f-43e7-8735-c0ab38072ded',
      type: 'Sprite',
      name: 'stayButton',
      nameSpace: '',
      className: '',
      x: 190,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '3b850417-8c43-4fb4-aea5-eaa74173a635',
      type: 'Sprite',
      name: 'leaveButton',
      nameSpace: '',
      className: '',
      x: -190,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_red',
      parent: '2cb68b51-e36f-46e7-bf9c-7da2e1525311',
      data: ''
    },
    {
      id: '77540095-cf36-48e2-8d30-581a4cf67657',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LeavingAlready?',
      localize: true,
      maxWidth: 400,
      maxHeight: 74,
      maxFontSize: 52,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#9A3234',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0eb21893-d197-43c7-b34a-30805b204fa2',
      data: ''
    },
    {
      id: '25453a0b-2f1c-48dd-a577-fdd1e20e92c5',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PlayAgain',
      localize: true,
      maxWidth: 213,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#074829',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '15a08cd5-9a0f-43e7-8735-c0ab38072ded',
      data: ''
    },
    {
      id: '204cc88c-3b82-4b43-96ed-4d21dcbf1e7e',
      type: 'Text',
      name: 'quitButtonText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Leave',
      localize: true,
      maxWidth: 175,
      maxHeight: 73,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#81242c',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 140,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3b850417-8c43-4fb4-aea5-eaa74173a635',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class QuitPlinkoMinigamePopupLayout {
  static raw = raw;
  root: PIXI.Container
  closeButton: PIXI.Sprite
  stayButton: PIXI.Sprite
  leaveButton: PIXI.Sprite
  quitButtonText: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
